import SwiperCarousel from '../externals/swiper/swiperCarousel';

class PartnerSlider extends SwiperCarousel {
	constructor(config) {
		super(Object.assign({
			scope: '.partner_slider .swiper-partners'
		}, config));
	}
}

export default new PartnerSlider;